import React, { useRef, useEffect, useCallback, useState} from 'react';
import DraggingEdge from './DraggingEdge.js';
import MarkovEdge from "components/groups/MarkovEdge.js"
import {
    setTransformationEdgeDragging} from 'actions/index.js';
import {MARKOV} from 'pattern/groups/transformations.js';
import {connect} from 'react-redux';

const GroupEdges = ({
    stepsGroupMode,
    scrollContainer,
    sequencerEngine,
    setTransformationEdgeDragging,
}) => { 
    let ref = useRef(undefined);
    
    
    useEffect(() => {
        window.addEventListener("mouseup", onMouseUp);
        window.addEventListener("mousemove", onMouseMove);

        return () => {
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("mousemove", onMouseMove);
        };
    }, []);

    const onMouseUp = useCallback((e) => {
        if (sequencerEngine.state.groups.stepsGroupMode) {
            setTransformationEdgeDragging(undefined);
        }
    },  []);

    const onMouseMove = useCallback((e) => {
        let dragging = sequencerEngine.state.groups.transformationEdgeDragging;
        if (!dragging) { return; }
        let x = e.pageX;
        let y = e.pageY;
        setTransformationEdgeDragging({
            ... dragging,
            x,
            y
        });
    }, []);

    if (!stepsGroupMode) {
        return [];
    }
    let markovTransformations = sequencerEngine.tracks.map(
        (track) => track.pattern.getAllGroups().map(g => g.transformations.filter(x => x.whenType === MARKOV).map(
            t => ({transformation: t, track})))
            .reduce((a,b) => [...a,...b], []))
        .reduce((a,b) => [...a, ...b], []);
    let style = {
        height: scrollContainer.current && scrollContainer.current.scrollHeight 
    };

    if (!scrollContainer.current) {
        return [];
    }
    return (
        <svg
          style={style} ref={ref} className="group-edges">
          <defs>
            <marker id="arrowhead" markerWidth="10" markerHeight="8" 
	            refX="4" refY="2" orient="auto">
              <polygon points="0 0, 5 2, 0 4" />
            </marker>
          </defs>
          <DraggingEdge scrollContainer={scrollContainer} container={ref}/>
        {markovTransformations.map(
            ({transformation, track}) =>
                <MarkovEdge
                  key={transformation.id}
                  scrollContainer={scrollContainer}
                  track={track}
                  container={ref}
                  transformation={transformation}/>)}
        </svg>);
};

const mapStateToProps = (state, props) => {
  return {
      stepsGroupMode: state.groups.stepsGroupMode,
      trackSteps: state.tracks.trackSteps[0],
      isDragging: state.groups.transformationEdgeDragging !== undefined
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setTransformationEdgeDragging: x => dispatch(setTransformationEdgeDragging(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupEdges);
